import { Model } from "./Base.js";

export class StatusModel extends Model {
    get defaults() {
        return {
            nome: "",
            usuario: "",
            data: "",
        };
    }
}